import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Container, Modal, Row, Col, Button, Form, Tooltip, Spinner} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import APICom from "../utils/helpers/APICom.js";
import {Icon} from '@iconify/react';
import * as XLSX from 'xlsx';
import GridControl from "../components/Controls/gridControl.js";
import PersistStorage from "../utils/helpers/PersistStorage.js";
import MultiSelectDropdown from '../components/Controls/multiselectdropdown.js';
import CommonFunctions from "../utils/helpers/CommonFunctions";
import ExportIcon from "../assets/Images/CommonImages/save.png";
import ClearFilterIcon from "../assets/Images/CommonImages/clearFilter.png";
import ITCLogo from "../assets/Images/CommonImages/ITClogo.png";
import DriverAlerts from "../components/Dispatch/Alerts/DriverAlerts";


const ZoneSpeedMultiplierComponent = () => {
    const [fromZoneValue, setFromZoneValue] = useState("");
    const [toZoneValue, setToZoneValue] = useState("");
    const [multiplierValue, setMultiplierValue] = useState("");
    const [RowIDValue, setRowIDValue] = useState(-1);
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const [selectRowData, setSelectedRowData] = useState([]);
    const [showAlert, setAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({alertTitle: '', alertMsg: ''});
    const {AffiliateData} = useSelector((store) => store.combinedata);
    const [DeleteBtnClass, setDeleteBtnClass] = useState("border-0 d-none");
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [ModalButtonText, setModalButtonText] = useState("Save");
    const [modalFooterHTML, setModalFooterHTML] = useState(
        <Modal.Footer className='p-0 px-2 py-1' style={{backgroundColor: "#4c859b"}}>
            <Button variant='danger' className={DeleteBtnClass} id={"ZoneSpeedModalDeleteBtn"}
                    onClick={() => DeleteZoneSpeedMultiplier()}>
                Delete
            </Button>
            <Button variant='dark' className="border-0 tripDetails_edit_btn_color "
                    onClick={() => SaveUpdateZoneSpeedMultiplier()}>
                {ModalButtonText}
            </Button>
        </Modal.Footer>
    );
    const {isLoggedIn, loginData} = useSelector((store) => store.login);
    const speedZoneTableObjRef = useRef(null);
    const [speedZoneTableData, setSpeedZoneTableData] = useState([]);
    const [selectedAffiliate, setSelectedAffiliate] = useState("-1");
    const [CallAgentDefaultAffiliateID, setCallAgentDefaultAffiliateID] = useState(loginData.DefaultAffiliateID);
    const [AffiliatesFilterMultiSelect, SetAffiliatesFilterMultiSelect] = useState({
        options: [],
        selectedValues: [CallAgentDefaultAffiliateID],
        placeholder: "Select Affiliates",
        displayValue: "name",
        emptyRecordMsg: "N/A",
        id: "DispatchGridAffiliatesSelect",
        className: "DispatchGridAffiliatesSelect text-nowrap",
        singleSelect: true,
        showCheckbox: false,
        TriggerSelectEventOnDataPopulate: false,
        styles: {width: "auto", marginLeft: "3px"}
    });
    const [ToZoneSelect, SetToZOneSelect] = useState({
        options: [],
        selectedValues: [],
        placeholder: "Select To Zone",
        displayValue: "name",
        emptyRecordMsg: "N/A",
        id: "ToZoneSelect",
        className: "ToZoneSelect text-nowrap",
        singleSelect: true,
        showCheckbox: false,
        TriggerSelectEventOnDataPopulate: false,
        styles: {width: "auto", marginLeft: "3px"}
    });
    const [FromZoneSelect, SetFromZoneSelect] = useState({
        options: [],
        selectedValues: [],
        placeholder: "Select From Zone",
        displayValue: "name",
        emptyRecordMsg: "N/A",
        id: "FromZoneSelect",
        className: "FromZoneSelect text-nowrap",
        singleSelect: true,
        showCheckbox: false,
        TriggerSelectEventOnDataPopulate: false,
        styles: {width: "auto", marginLeft: "3px"}
    });

    const ChangeMultiplierValue = (multiplier) => {
        setMultiplierValue(multiplier);
    }
    const isNonNegativeNumber = (str) => {
        if (typeof str === "number"){
            str = multiplierValue.toString();
        }
        if (typeof str !== "string" || str.trim() === "") return false; // Reject non-strings or empty input
        return /^(0*[1-9]\d*(\.\d+)?|0*\.\d+)$/.test(str);
    }

    const [speedZoneGridOptions, setSpeedZoneGridOptions] = useState({
        height: 750,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        sortCondition: true,
        paginationMode: "local",
        paginationSize: 100,
        paginationSizeSelector: [100, 200, 300, 400, 500],
        selectable: 1,
        reactiveData: false,
        layout: "fitColumns",
        placeholder: "No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName: "speedZoneTable",
        paginationCounter: "rows",
        intervalTimer: 0,
        movableColumns: true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "RowID",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '',
        tableDoubleClickFunc: function (table, row) {
            try {
                let rowData = row.getData()
                GridRowDoubleClick(row,rowData);
            } catch (err) {
                console.log(err);
            }
        },
        footerElementHandles: function (table) {
            speedZoneTableObjRef.current = table;
        },
        rowSelectionChangeHandle: function (data) {
            try {
                setSelectedRowData(data)
            } catch (err) {
                console.log(err);
            }
        },
        ActionList: false,
        listofCheckBoxCols: [],
        AlwaysHiddenColumns: ["RowID"]
    });

    const DeleteZoneSpeedMultiplier = async ( ) => {
        setShowDynamicModal(false)
        let data = {
            "RowID": RowIDValue,
            "bDelete": true
        }
        setToZoneValue(data["To Zone"])
        setMultiplierValue(data["Multiplier"])
        setRowIDValue(data["RowID"])
        let response = await APICom.fetchData("ReservationCoreURL", "Common/InsertUpdateDeleteZoneSpeedMultiplier", "post", {"Content-Type": "application/json"}, data, null);
        if (response.data.Status) {
            setAlertObj({
                ...alertObj,
                alertTitle: 'Success',
                alertMsg: 'Record Deleted Successfully.'
            });
            setAlert(true);
        } else {

            setAlertObj({
                ...alertObj,
                alertTitle: 'Failed',
                alertMsg: 'Record Deletion failed.'
            });
        }
        PrepareGridRequest()

    }

    const SaveUpdateZoneSpeedMultiplier = async () => {
        if (!fromZoneValue.trim() && fromZoneValue === "" && !toZoneValue.trim() && toZoneValue === "") {
            setAlertObj({
                ...alertObj,
                alertTitle: 'Alert',
                alertMsg: 'To Zone From zone both cannot be empty.'
            });
            setAlert(true);
        } else if (!isNonNegativeNumber(multiplierValue)) {
            setAlertObj({
                ...alertObj,
                alertTitle: 'Alert',
                alertMsg: 'Multiplier should be numeric value greater than 0.'
            });
            setAlert(true);
        }
        else
        {
            setShowDynamicModal(false)
            let data = {
                "AffiliateID": selectedAffiliate[0],
                "RowID": RowIDValue,
                "FromZone": fromZoneValue,
                "ToZone": toZoneValue,
                "Multiplier": multiplierValue,
                "UserID": loginData.recordID,
                "bDelete": false
            }
            let response = await APICom.fetchData("ReservationCoreURL", "Common/InsertUpdateDeleteZoneSpeedMultiplier", "post", {"Content-Type": "application/json"}, data, null);
            if (response.data.Status) {
                if (RowIDValue > 0) {
                    setAlertObj({
                        ...alertObj,
                        alertTitle: 'Success',
                        alertMsg: 'Record Updated Successfully.'
                    });
                } else {
                    setAlertObj({
                        ...alertObj,
                        alertTitle: 'Success',
                        alertMsg: 'Record Added Successfully.'
                    });
                }
                setAlert(true);
            }else {
               if (RowIDValue > 0) {
                   setAlertObj({
                       ...alertObj,
                       alertTitle: 'Failed',
                       alertMsg: 'Record Updation failed.'
                   });
               } else {
                   setAlertObj({
                       ...alertObj,
                       alertTitle: 'Failed',
                       alertMsg: 'Record Insertion failed.'
                   });
               }
            }
            PrepareGridRequest()
        }

    }

    const PrepareGridRequest = async () => {
        const data = {
            "AffiliateID": selectedAffiliate[0]
        }
        setShowGridLoader(true);
        let response = await APICom.fetchData("ReservationCoreURL", "Common/GetZoneSpeedMultiplier", "post", {"Content-Type": "application/json"}, data, null);
        let emptyData = [{
            "RowID": -1,
            "From Zone": "",
            "To Zone": "",
            "Multiplier": "",
            "Creation Date": "",
            "Modified Date": ""
        }]
        if (response.data.length > 0) {
            setSpeedZoneTableData(response.data)
        } else {
            setSpeedZoneTableData(emptyData)
        }
        setShowGridLoader(false);
    }

    const PrepareZoneDropDown = async () => {
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Settings/GetZones", "get", {"Content-Type": "application/json"}, null, null);
        let optsFromZones = [];
        let optsToZones = [];
        let zoneData = response.data

        if (zoneData && zoneData.length > 0) {
            for (let i = 0; i < zoneData.length; i++) {
                optsFromZones.push({
                    "name": zoneData[i]["ZoneName"],
                    "id": zoneData[i]["ZoneName"]
                });
                optsToZones.push({
                    "name": zoneData[i]["ZoneName"],
                    "id": zoneData[i]["ZoneName"]
                });
            }
        }

        SetToZOneSelect({
            ...ToZoneSelect, ...{
                options: optsToZones,
                selectedValues: optsToZones[0].id.toString()
            }
        });
        SetFromZoneSelect({
            ...FromZoneSelect, ...{
                options: optsFromZones,
                selectedValues: optsFromZones[0].id.toString()
            }
        });
        setToZoneValue(optsToZones[0].id.toString())
        setFromZoneValue(optsFromZones[0].id.toString())
    }

    const GridRowSelect = (rowData) => {
        setSelectedRowData(rowData);
    }

    const GridRowDoubleClick =  (row, data) => {
        setShowDynamicModal(true)
        setModalHeaderText("Update Record")
        setModalButtonText("Update")
           // Set selected values in dropdowns
        SetFromZoneSelect(prevState => ({
            ...prevState,
            selectedValues: [data["From Zone"]]
        }));

        SetToZOneSelect(prevState => ({
            ...prevState,
            selectedValues: [data["To Zone"]]
        }));

        setMultiplierValue(data["Multiplier"])
        setRowIDValue(data["RowID"])
        setModalButtonText("Update")
        setDeleteBtnClass("border-0")
    }

    const FilterOptionsAccordingToSelectedAffiliates = (selectedAffiliate) => {
        setSelectedAffiliate(selectedAffiliate)
    }

    const ToZoneCallBack = (selectedToZone) => {
        setToZoneValue(selectedToZone[0])
    }

    const FromZoneCallBack = (selectedFromZone) => {
        setFromZoneValue(selectedFromZone[0])
    }

const hanldeOpenZoneCriteriaModal = () => {
    setModalHeaderText("Add New");
    setModalButtonText("Save");
    setShowDynamicModal(true);
    setRowIDValue(-1);
    setDeleteBtnClass("border-0 d-none");

    // Set default values to the first option of each dropdown
    if (FromZoneSelect.options.length > 0) {
        setFromZoneValue(FromZoneSelect.options[0].id); // Select first "From Zone"
        SetFromZoneSelect(prevState => ({
            ...prevState,
            selectedValues: [FromZoneSelect.options[0].id]
        }));
    }

    if (ToZoneSelect.options.length > 0) {
        setToZoneValue(ToZoneSelect.options[0].id); // Select first "To Zone"
        SetToZOneSelect(prevState => ({
            ...prevState,
            selectedValues: [ToZoneSelect.options[0].id]
        }));
    }

    setMultiplierValue(""); // Reset multiplier field
};


    useEffect(() => {
        document.title = "Zone Speed Multiplier";

        const PopulateAffiliateMultiSelect = () => {
            let optsAffiliates = [];
            let allowedaffiliates = loginData.UserAffiliateList.split(',');
            let allowedValidAffiliates = [];
            if (allowedaffiliates.length > 0) {
                try {
                    for (var i = 0; i < AffiliateData.length; i++) {
                        if (allowedaffiliates.indexOf(AffiliateData[i]["AffiliateID"].toString()) > -1) {
                            allowedValidAffiliates.push(AffiliateData[i]["AffiliateID"].toString());
                        }
                    }
                } catch (o) {
                }
            }
            for (let i = 0; i < AffiliateData.length; i++) {
                optsAffiliates.push({
                    "name": AffiliateData[i]["AffiliateCompany"],
                    "id": AffiliateData[i]["AffiliateID"]
                });
            }
            let storedSelection = PersistStorage.retrieve("affSelectedCallAgent", true);
            SetAffiliatesFilterMultiSelect({
                ...AffiliatesFilterMultiSelect, ...{
                    options: optsAffiliates,
                    selectedValues: storedSelection ? [storedSelection.toString()] : [optsAffiliates[0].id.toString()]
                }
            });
        }
        PopulateAffiliateMultiSelect();
        PrepareZoneDropDown();
    }, []);


    useEffect(() => {
        if(selectedAffiliate !== "-1"){
            PrepareGridRequest();
        }
    }, [selectedAffiliate]);
 const DynamicStyles = `
        .ZoneSelectCol > .MultiSelectDropdownCommon {
            margin-left: 0px !important;
            width: auto !important;
        }
        
        .form-select {
            margin-left: 0px !important;
        }

        .modal-content {
            border-radius: 10px !important;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2) !important;
        }

        .tripDetails-label {
            font-weight: bold !important;
            color: #333 !important;
        }

        /* Override Bootstrap button styles */
        .tripaction_btn_color {
            background-color: #4c859b !important;
            border-radius: 5px !important;
            color: white !important;
        }
    `;


    return (

        <div>
             <style dangerouslySetInnerHTML={{ __html: DynamicStyles }} />
            <nav className="navbar fixed-top navbar-expand-lg page-header d-block" style={{height: '80px'}}>

                <Col className="d-flex my-auto align-items-center">
                    <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none' alt="ITCurves"/>
                    <p className="fw-bold text-white text-center text-nowrap callAgentTitleResponsiveNoMargin overflow-hidden h3 user-select-none flex-grow-1"
                       style={{margin: "0"}}>
                        <>
                            <span className="callAgentLabelsResponsive">Zone Speed Multiplier</span>
                        </>
                    </p>
                    <span className="d-inline-flex text-end callAgentTitleAffResponsive"
                          style={{marginRight: "9%"}}> </span>
                </Col>
                <Col className="d-flex my-auto align-items-center">
                    <p className="text-white text-center text-nowrap callAgentTitleResponsive overflow-hidden  user-select-none flex-grow-1"
                       style={{margin: "0"}}>
                        <>
                            <span className="callAgentLabelsResponsive">To customize vehicle speed based upon geographic zones - help improve trip estimation & ETA.</span>
                        </>
                    </p>
                    <span className="d-inline-flex text-end callAgentTitleAffResponsive"
                          style={{marginRight: "9%"}}> </span>
                </Col>
            </nav>


            <Row className={"m-0 border border-secondary"}>
                <Col style={{height: "80px"}} lg={2}>
                    <MultiSelectDropdown options={AffiliatesFilterMultiSelect} singleselect="true"
                                         style={{paddingLeft: '5px'}}
                                         SelectionChangeCallback={FilterOptionsAccordingToSelectedAffiliates}/>
                </Col>
                <Col lg={1}>
                    <Button onClick={hanldeOpenZoneCriteriaModal} className="tripaction_btn_color tripaction_btn_width"
                            style={{marginTop: '25px'}}
                    > Add New
                    </Button>
                </Col>
            </Row>
            <Row className={"m-0 mt-2"}>
                <Col>
                    <GridControl
                        setSelectedRowData={GridRowSelect} options={speedZoneGridOptions}
                        Data={speedZoneTableData}
                        ShowLoader={ShowGridLoader} GridRowDoubleClick={GridRowDoubleClick}
                    />
                </Col>
            </Row>

            {showDynamicModal ?
                <Modal centered backdrop="static" keyboard={true}
                       onHide={() => {
                           setShowDynamicModal(false)
                       }} show={showDynamicModal} animation={true}>
                    <Modal.Header
                        className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header activate_dialog_header_bgcolor tripDetails-DialogHeader'
                        closeButton>
                        <Modal.Title style={{fontSize: "20px"}}>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='fw-normal user-select-none'>
                        <Row className="border rounded py-1">
                            <Col xs={12} className="user-select-none mt-2">
                                <Row>
                                    <Col xs={4}>
                                        <label className="tripDetails-label">
                                <span
                                    className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    where_to_vote
                                </span>
                                            From Zone:
                                        </label>
                                    </Col>
                                    <Col xs={8} className="ZoneSelectCol">
                                        <MultiSelectDropdown options={FromZoneSelect} singleselect="true"
                                         SelectionChangeCallback={FromZoneCallBack}/>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs={12} className="user-select-none mt-2">
                                <Row>
                                    <Col xs={4}>
                                        <label className="tripDetails-label">
                                    <span
                                        className="material-symbols-outlined tripDetails-googlefonts-icon">
                                        pin_drop
                                    </span>
                                            To Zone:
                                        </label>
                                    </Col>
                                    <Col xs={8}  className="ZoneSelectCol">
                                        <MultiSelectDropdown options={ToZoneSelect} singleselect="true"
                                         SelectionChangeCallback={ToZoneCallBack}/>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs={12} className="user-select-none mt-2">
                                <Row>
                                    <Col xs={4}>
                                        <label className="tripDetails-label">
                                <span
                                    className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    calculate
                                </span>
                                            Multiplier
                                        </label>
                                    </Col>
                                    <Col xs={8}>
                                        <input className="tripDetails-label-dataFields w-100 form-control"
                                               placeholder="Multiplier"
                                               value={multiplierValue}
                                               onChange={(e) => {
                                                   ChangeMultiplierValue(e.target.value)
                                               }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Modal.Body>
                    {modalFooterHTML === "" ? "" :
                        <Modal.Footer className='p-0 px-2 py-1' style={{backgroundColor: "#4c859b"}}>
                            <Button variant='danger' className={DeleteBtnClass} id={"ZoneSpeedModalDeleteBtn"}
                                    onClick={() => DeleteZoneSpeedMultiplier()}>
                                Delete
                            </Button>
                            <Button variant='dark' className="border-0 tripDetails_edit_btn_color "
                                    onClick={() => SaveUpdateZoneSpeedMultiplier()}>
                                {ModalButtonText}
                            </Button>
                        </Modal.Footer>
                    }
                </Modal>
                : ""}

            {showAlert && <Modal centered show={showAlert} onHide={() => setAlert(false)} animation={false}>
                <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                    <Modal.Title className='activate_dialog_title_color'>{alertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{alertObj.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setAlert(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}

        </div>

    );
};

export default ZoneSpeedMultiplierComponent;